<template>
<section class="termsBox">

    <h2 class="conTit1 mgt1 insuranceTitleA">기업비용보상보험 보통약관</h2>

    <h2 class="conTit2 marginTB alignC">제1관 용어의 정의</h2>

    <div class="termsCon" id="termsPart1">

        <h2 class="termsTit">제1조 (용어의 정의)</h2>

        <p>이 계약에서 사용되는 용어의 정의는 이 계약의 다른 조항에서 달리 정의되지 않는 한 다음과 같습니다</p>
        
        <ol class="circleNum">
            <li>1. 계약 관련 용어
                <ol class="numList">
                    <li>가. 계약자: 회사와 계약을 체결하고 보험료를 납입할 의무를 지는 사람을 말합니다.</li>
                    <li>나. 피보험자(또는 서비스가입고객): 보험사고로 인하여 손해를 입은 사람(법인인 경우에는 그 이사 또는 법인의 업무를 집행하는 그 밖의 기관)을 말합니다. </li>
                    <li>다. 보험증권: 계약의 성립과 그 내용을 증명하기 위하여 회사가 계약자에게 드리는 증서를 말합니다.</li>
                </ol>
            </li>
            <li>2. 보상 관련 용어
                <ol class="numList">
                    <li>가. 보험가입금액: 회사와 계약자간에 약정한 금액으로 보험사고가 발생할 때 회사가 지급할 최대 보험금을 말합니다.</li>
                    <li>나. 보험가액: 재산보험에 있어 피보험 이익을 금전으로 평가한 금액으로 보험목적에 발생할 수 있는 최대 손해액을 말합니다.(회사가 실제 지급하는 보험금은 보험가액을 초과할 수 없습니다)</li>
                    <li>다. 자기부담금: 보험사고로 인하여 발생한 손해에 대하여 계약자 또는 피보험자가 부담하는 일정 금액을 말합니다</li>
                    <li>라. 보험금 분담: 이 계약에서 보장하는 위험과 같은 위험을 보장하는 다른 계약(공제계약을 포함합니 다)이 있을 경우 비율에 따라 손해를 보상합니다.</li>
                    <li>마. 대위권: 회사가 보험금을 지급하고 취득하는 법률상의 권리를 말합니다.</li>
                </ol>
            </li>
            <li>3. 이자율 관련 용어
                <ol class="numList">
                    <li>가. 연단위 복리: 회사가 지급할 금전에 이자를 줄 때 1년마다 마지막 날에 그 이자를 원금에 더한 금액을 다음 1년의 원금으로 하는 이자 계산방법을 말합니다.</li>
                    <li>나. 보험개발원이 공시하는 보험계약대출이율: 보험개발원이 정기적으로 산출하여 공시하는 이율로써 회사가 보험금의 지급 또는 보험료의 환급을 지연하는 경우 등에 적용합니다.</li>
                </ol>
            </li>
            <li>4. 기간과 날짜 관련 용어
                <ol class="numList">
                    <li>가. 보험기간: 계약에 따라 보장을 받는 기간을 말합니다.</li>
                    <li>나. 영업일: 회사가 영업점에서 정상적으로 영업하는 날을 말하며, 토요일,‘관공서의 공휴일에 관한 규정’에 따른 공휴일 및 대체공휴일, ‘근로자의 날 제정에 관한 법률’에 따른 근로자의 날을 제외합니다.</li>
                </ol>
            </li>
        </ol>

    </div>

    <h2 class="conTit2 marginTB alignC">제2관 보험금의 지급</h2>

    <div class="termsCon" id="termsPart2">
        <h2 class="termsTit">제2조 (보상하는 손해)</h2>
        <p>회사는 보험증권상의 보장지역 내에서 보험기간 중에 발생한 특별약관에 기재된 비용을 약관에 따라 보상하여 드립니다.</p>
    </div>

    <div class="termsCon" id="termsPart3">
        <h2 class="termsTit">제3조 (보상하지 않는 손해)</h2>
        <p>회사는 아래의 사항을 직·간접적인 원인이나 결과로 하여 발생된 손해에 대해서는 보상하지 않습니다.</p>
        <ol class="circleNum">
            <li>1. 피보험자(또는 서비스가입고객)의 고의 또는 중대한 과실</li>
            <li>2. 피보험자(또는 서비스가입고객) 및 그 대리인의 사기, 부실고지 또는 은폐행위</li>
            <li>3. 전쟁 또는 전쟁위협, 침입, 외국군대의 행위, 선전포고 여부를 불문하고 적대적인 시민전쟁, 혁명, 군대의 반란 또는 정권찬탈, 몰수, 국유화, 정부·공공기관·지방정부의 명령에 의한 재물에 대한 징발, 파괴, 또는 손실</li>
            <li>4. 민중봉기, 폭동 또는 시민소요에 준하는 사태, 폭동, 계엄령 또는 공공질서의 유지를 위해 합법적으로 구성된 기관의 행위</li>
            <li>5. 검역소 또는 세관의 규제하의 압류 및 파괴행위, 정부기관, 공공기관 또는 기타지방정부기관의 명령에 의한 재물의 몰수, 국유화, 징발, 파괴, 손실, 또는 밀수품의 취급이나 불법적인 무역 또는 수송</li>
            <li>6. 그 종류를 불문하고 시민 또는 주민들에게 강제할 것을 명령하는 국가의 법령 또는 법률의 집행, 그 종류를 불문하고 본국송환, 억류, 투옥, 추방, 또는 이 보험의 목적이 되는 행사가 열리는 장소 또는 국가 내로의 진입허가 및 잔류허가의 취소</li>
            <li>7. 가) 핵연료 또는 핵연료의 연소로부터 발생된 핵 폐기물에 의해 야기된 방사능오염 또는 이온화방사<br>
                나) 폭발성의 핵 조립시설 및 그곳의 핵 부품의 위험한 재물에 의한 방사능 물질, 독성물질, 폭발물 또는 기타 위험한 재물</li>
            <li>8. 지진, 분화, 해일, 태풍, 홍수 등의 천재지변에 의한 손해</li>
            <li>9. 이 보험계약에서 보상하는 손실에 직접적으로 기인되지 않은 이 보험계약의 보험기간 동안에 발견되어지지 않았던 유출, 대기오염, 수질오염</li>
            <li>10. 환율, 세금, 이자, 또는 통화의 안정성에 있어서의 변화</li>
            <li>가) 그 원인을 불문하고 파이낸스의 회수, 불충분, 부족<br>
                나) 지급불능, 재정적 실패 또는 채무불이행, 지불불능, 파산, 청산, 해산, 채권자의 권리행사 또는  합의<br>
                다) 그 사람, 업체, 조직이 보험계약의 당사자인지의 여부를 불문하고, 이러한 사람, 업체, 또는 조직 으로부터의 대응 또는 지원의 부족 또는 불충분함, 또는 지원의 철회
            </li>
            <li>12. 이 계약에서 보장하는 위험과 같은 위험을 보장하는 다른 보험계약이 존재하는 경우. 단, 다른 보험계약에 의해 보상되어지는 금액을 초과하는 손해의 부분에 대해서는 이 보험계약으로 보상하여 드립니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart4">
        <h2 class="termsTit">제4조 (손해의 통지 및 조사)</h2>
        <ol class="circleNum">
            <li>① 계약자 또는 피보험자는 아래와 같은 사실이 있는 경우에는 지체 없이 그 내용을 서면으로 회사에 알려야 합니다.
                <ol class="numList">
                    <li>1. 사고가 발생하였을 경우 사고가 발생한 때와 곳, 피해자의 주소와 성명, 사고 상황 및 이들 사항의 증인이 있을 경우 그 주소와 성명</li>
                    <li>2. 피해자로부터 손해배상청구를 받았을 경우</li>
                    <li>3. 피해자로부터 손해배상책임에 관한 소송을 제기 받았을 경우</li>
                </ol>
            </li>
            <li>② 계약자 또는 피보험자가 제1항 각호의 통지를 게을리 하여 손해가 증가된 때에는 회사는 그 증가된 손해를 보상하여 드리지 않으며, 제1항 제3호의 통지를 게을리 한 때에는 소송비용과 변호사비용도 보상하여 드리지 않습니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart5">
        <h2 class="termsTit">제5조 (보험금의 청구)</h2>
        <ol class="circleNum">
            <li>① 피보험자가 보험금을 청구할 때에는 다음의 서류를 회사에 제출하여야 합니다.
                <ol class="numList">
                    <li>1. 보험금 청구서</li>
                    <li>2. 신분증(주민등록증 또는 운전면허증 등 사진이 부착된 정부기관발행 신분증, 본인이 아닌 경우에는 본인의 인감증명서 또는 본인서명사실확인서</li>
                    <li>3. 손해배상금 및 그 밖의 비용을 지급하였음을 증명하는 서류</li>
                    <li>4. 회사가 요구하는 그 밖의 서류</li>
                </ol>
            </li>
            <li>② 회사는 제1항에 따른 보험금 청구를 받은 후 지체 없이 지급할 보험금을 결정하고 지급할 보험금이 결정되면 7일 이내에 이를 지급하여 드립니다.</li>
            <li>③ 회사는 제2항의 지급보험금이 결정된 후 7일이 지나도록 보험금을 지급하지 않았을 때에는 지체된 날부터 지급일까지 보험개발원이 매월 공시하는 1년 만기 보험계약대출이율을 연 단위 복리로 계산한 금액을 지급합니다. 그러나 피보험자의 책임 있는 사유로 지체된 경우에는 그러하지 않습니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart6">
        <h2 class="termsTit">제6조 (보험금의 지급절차)</h2>
        <ol class="circleNum">
            <li>① 회사는 제5조(보험금의 청구)에서 정한 서류를 접수한 때에는 접수증을 교부하고, 그 서류를 접수받은 후 지체 없이 지급할 보험금을 결정하고 지급할 보험금이 결정되면 7일 이내에 이를 지급하여 드립니다. 또한, 지급할 보험금이 결정되기 전이라도 피보험자의 청구가 있을 때에는 회사가 추정한 보험금의 50% 상당액을 가지급보험금으로 지급합니다. </li>
            <li>② 회사가 제1항의 지급보험금이 결정된 후 7일이 지나도록 보험금을 지급하지 않았을 때에는 늦어진 날부터 지급일까지의 기간에 대하여 [부표1] ‘보험금을 지급할 때의 적립이율’에 따라 연단위 복리로 계산한 금액을 보험금에 더하여 지급합니다. 그러나 피보험자의 책임있는 사유로 늦어진 경우에는 그 해당기간에 대한 이자를 더하여 지급하지 않습니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart7">
        <h2 class="termsTit">제7조 (보험금 등의 지급한도)</h2>
        <ol class="circleNum">
            <li>① 회사는 1회의 보험사고에 대하여 보험가입금액(보상한도액)을 한도로 보상하되, 자기부담금이 약정된 경우에는 그 자기부담금을 초과한 부분만 보상합니다. 이 경우 보험가입금액(보상한도액)과 자기부담금은 각각 보험증권에 기재된 금액을 말합니다.</li>
            <li>② 회사는 계약자와 협의하여 총보상한도액을 설정하여 운영할 수 있으며, 그 경우 제 1항에 따른 보상액을 뺀 잔액을 나머지 보험기간에 대한 총보상한도액으로 합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart8">
        <h2 class="termsTit">제8조 (손해방지의무)</h2>
        <p>보험사고가 생긴 때에는 계약자 또는 피보험자는 손해의 방지와 경감에 힘써야 합니다. 만약, 계약자 또는 피보험자가 고의 또는 중대한 과실로 이를 게을리 한 때에는 방지 또는 경감할 수 있었을 것으로 밝혀진 값을 손해액에서 뺍니다.</p>
    </div>

    <div class="termsCon" id="termsPart9">
        <h2 class="termsTit">제9조 (대위권)</h2>
        <ol class="circleNum">
            <li>① 회사가 보험금을 지급한 때(현물 보상한 경우를 포함합니다)에는 회사는 지급한 보험금의 한도 내에서 아래의 권리를 가집니다. 다만, 회사가 보상한 금액이 피보험자가 입은 손해의 일부인 경우에는 피보험자의 권리를 침해하지 않는 범위 내에서 그 권리를 가집니다.
                <ol class="numList">
                    <li>1. 피보험자가 제3자로부터 손해배상을 받을 수 있는 경우에는 그 손해배상청구권</li>
                    <li>2. 피보험자가 손해배상을 함으로써 대위 취득하는 것이 있을 경우에는 그 대위권</li>
                </ol>
            </li>
            <li>② 계약자 또는 피보험자는 제1항에 의하여 회사가 취득한 권리를 행사하거나 지키는 것에 관하여 조치를 하여야 하며, 또한 회사가 요구하는 증거 및 서류를 제출하여야 합니다.</li>
            <li>③ 회사는 제1항, 제2항에도 불구하고 타인을 위한 보험계약의 경우에는 계약자에 대한 대위권을 포기합니다</li>
        </ol>
    </div>


    <h2 class="conTit2 marginTB alignC">제3관 계약자의 계약 전 알릴 의무 등</h2>


    <div class="termsCon" id="termsPart10">
        <h2 class="termsTit">제10조 (계약 전 알릴 의무)</h2>
        <p>계약자, 피보험자 또는 이들의 대리인은 청약시 청약서(질문서를 포함합니다)에서 질문한 사항에 대하여 알고 있는 사실을 반드시 사실대로 알려야 합니다.</p>
    </div>

    <div class="termsCon" id="termsPart11">
        <h2 class="termsTit">제11조 (계약 후 알릴 의무)</h2>
        <ol class="circleNum">
            <li>① 계약을 맺은 후 보험의 목적에 아래와 같은 사실이 생긴 경우에는 계약자나 피보험자는 지체 없이 서면으로 회사에 알리고 보험증권에 확인을 받아야 합니다.
                <ol class="numList">
                    <li>1. 청약서의 기재사항을 변경하고자 할 때 또는 변경이 생겼음을 알았을 때</li>
                    <li>2. 이 계약에서 보장하는 위험과 동일한 위험을 보장하는 계약을 다른 보험자와 체결하고자 할 때 또는 이와 같은 계약이 있음을 알았을 때</li>
                    <li>3. 위험이 뚜렷이 변경되거나 변경되었음을 알았을 때</li>
                    <li>4. 보통약관 및 특별약관에서 정한 계약 후 알릴 의무 사항이 발생한 때</li>
                </ol>
            </li>
            <li>② 회사는 제1항에 따라 위험이 감소된 경우에는 그 차액보험료를 돌려드리며, 위험이 증가된 경우에는 통지를 받은 날부터 1개월 이내에 보험료의 증액을 청구하거나 계약을 해지할 수 있습니다.</li>
            <li>③ 계약자는 주소 또는 연락처가 변경된 경우에는 지체 없이 이를 회사에 알려야 합니다. 다만, 계약자가 알리지 않은 경우 회사가 알고 있는 최종의 주소 또는 연락처로 등기우편 방법에 의해 계약자에게 알린 사항은 일반적으로 도달에 필요한 시일이 지난 때에는 계약자에게 도달한 것으로 봅니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart12">
        <h2 class="termsTit">제12조 (사기에 의한 계약)</h2>
        <p>계약자, 피보험자 또는 이들의 대리인의 사기에 의하여 계약이 성립되었음을 회사가 증명하는 경우에는 계약체결일부터 5년 이내(사기사실을 안 날부터 1개월 이내)에 계약을 취소할 수 있습니다.</p>
    </div>

    <h2 class="conTit2 marginTB alignC">제4관 보험계약의 성립과 유지</h2>

    <div class="termsCon" id="termsPart13">
        <h2 class="termsTit">제13조 (보험계약의 성립)</h2>
        <ol class="circleNum">
            <li>① 계약은 계약자의 청약과 회사의 승낙으로 이루어집니다.</li>
            <li>② 회사는 계약의 청약을 받고 보험료 전액 또는 제1회 보험료(이하 ‘제1회 보험료 등’이라 합니다)를 받은 경우에는 청약일부터 30일 이내에 승낙 또는 거절의 통지를 하며 통지가 없으면 승낙한 것으로 봅니다.</li>
            <li>③ 회사가 청약을 승낙한 때에는 지체 없이 보험증권을 계약자에게 교부하여 드리며, 청약을 거절한 경우에는 거절통지와 함께 받은 금액을 계약자에게 돌려드립니다.</li>
            <li>④ 이미 성립한 계약을 연장하거나 변경하는 경우에는 회사는 보험증권에 그 사실을 기재함으로써 보험증권의 교부에 대신할 수 있습니다. </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart14">
        <h2 class="termsTit">제14조 (청약의 철회)</h2>
        <ol class="circleNum">
            <li>① 계약자는 보험증권을 받은 날부터 15일 이내에 그 청약을 철회할 수 있습니다. 다만, 의무보험의 경우에는 철회의사를 표시한 시점에 동종의 다른 의무보험에 가입된 경우에만 철회할 수 있으며, 보험기간이 90일 이내인 계약 또는 전문금융소비자가 체결한 계약은 청약을 철회할 수 없습니다.</li>
            <div class="boxMade">
                【전문보험계약자】보험계약에 관한 전문성, 자산규모 등에 비추어 보험계약에 따른 위험감수능력이 있는 자로서, 국가, 지방자치단체, 한국은행, 금융회사, 주권상장법인 등을 포함하며 「금융소비자 보호에 관한 법률」제2조(정의) 제9호에서 정하는 전문금융소비자를 말합니다. <br>
                【일반금융소비자】전문금융소비자가 아닌 계약자를 말합니다.
            </div>
            <li>② 제1항에도 불구하고 청약한 날부터 30일이 초과된 계약은 청약을 철회할 수 없습니다.</li>
            <li>③ 청약철회는 계약자가 전화로 신청하거나, 철회의사를 표시하기 위한 서면, 전자우편, 휴대전화 문자메시지 또는 이에 준하는 전자적 의사표시(이하 ‘서면 등’이라 합니다)를 발송한 때 효력이 발생합니다. 계약자는 서면 등을 발송한 때에 그 발송 사실을 회사에 지체없이 알려야 합니다.</li>
            <li>④ 계약자가 청약을 철회한 때에는 회사는 청약의 철회를 접수한 날부터 3영업일 이내에 납입한 보험료를 계약자에게 돌려 드리며, 보험료 반환이 늦어진 기간에 대하여는 보험개발원이 공시하는 보험계약대출이율을 연단위 복리로 계산한 금액을 더하여 지급합니다. 다만, 계약자가 제1회 보험료 등을 신용카드로 납입한 계약의 청약을 철회하는 경우에 회사는 청약의 철회를 접수한 날부터 3영업일 이내에 해당 신용카드회사로 하여금 대금청구를 하지 않도록 해야 하며, 이 경우 회사는 보험료를 반환한 것으로 봅니다. </li>
            <li>⑤ 청약을 철회할 때에 이미 보험금 지급사유가 발생하였으나 계약자가 그 보험금 지급사유가 발생한 사실을 알지 못한 경우에는 청약철회의 효력은 발생하지 않습니다. </li>
            <li>⑥ 제1항에서 보험증권을 받은 날에 대한 다툼이 발생한 경우 회사가 이를 증명하여야 합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart15">
        <h2 class="termsTit">제15조 (약관교부 및 설명의무 등)</h2>
        <ol class="circleNum">
            <li>① 회사는 계약자가 청약할 때에 계약자에게 약관의 중요한 내용을 설명하여야 하며, 청약 후에 다음 각 호의 방법 중 계약자가 원하는 방법을 확인하여 지체 없이 약관 및 계약자 보관용 청약서를 제공하여 드립니다. 만약, 회사가 전자우편 및 전자적 의사표시로 제공한 경우 계약자 또는 그 대리인이 약관 및 계약자 보관용 청약서 등을 수신하였을 때에는 해당 문서를 드린 것으로 봅니다.
                <ol class="numList">
                    <li>1. 서면교부</li>
                    <li>2. 우편 또는 전자우편</li>
                    <li>3. 휴대전화 문자메시지 또는 이에 준하는 전자적 의사표시</li>
                </ol>
            </li>
            <li>② 제1항과 관련하여 통신판매계약의 경우, 회사는 계약자가 가입한 특약만 포함한 약관을 드리며, 계약자의 동의를 얻어 다음 중 한 가지 방법으로 약관의 중요한 내용을 설명할 수 있습니다. 
                <ol class="numList">
                    <li>1. 인터넷 홈페이지에서 약관 및 그 설명문(약관의 중요한 내용을 설명한 문서)을 읽거나 내려받게 하는 방법. 이 경우 계약자가 이를 읽거나 내려 받은 것을 확인한 때에 해당 약관을 드리고 그 중요한  내용을 설명한 것으로 봅니다.</li>
                    <li>2. 전화를 이용하여 청약내용, 보험료납입, 보험기간, 계약 전 알릴 의무, 약관의 중요한 내용 등 계약을 체결하는 데 필요한 사항을 질문 또는 설명하는 방법. 이 경우 계약자의 답변과 확인내용을 음성 녹음함으로써 약관의 중요한 내용을 설명한 것으로 봅니다</li>
                </ol>
            </li>
            <div class="boxMade">【통신판매계약】전화ㆍ우편ㆍ인터넷 등 통신수단을 이용하여 체결하는 계약을 말합니다.</div>
            <li>③ 회사가 제1항에 따라 제공될 약관 및 계약자 보관용 청약서를 청약할 때 계약자에게 전달하지 않거나 약관의 중요한 내용을 설명하지 않은 때 또는 계약을 체결할 때 계약자가 청약서에 자필서명을 하지 않은 때에는 계약자는 계약이 성립한 날부터 3개월 이내에 계약을 취소할 수 있습니다. </li>
            <div class="boxMade">【자필서명】날인(도장을 찍음) 및 전자서명법 제2조 제2호에 따른 전자서명을 포함합니다.</div>
            <li>④ 제3항에 따라 계약이 취소된 경우에는 회사는 이미 납입한 보험료를 계약자에게 돌려 드리며, 보험료를 받은 기간에 대하여 ‘보험개발원이 공시하는 보험계약대출이율’을 연단위 복리로 계산한 금액을 더하여 지급합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart16">
        <h2 class="termsTit">제16조 (계약의 무효)</h2>
        <p>계약을 맺을 때에 보험사고가 이미 발생하였을 경우 이 계약은 무효로 합니다. 다만, 회사의 고의 또는 과실로 계약이 무효로 된 경우와 회사가 승낙 전에 무효임을 알았거나 알 수 있었음에도 불구하고 보험료를 반환하지 않은 경우에는 보험료를 납입한 날의 다음날부터 반환일까지의 기간에 대하여 회사는 ‘보험개발원이 공시하는 보험계약대출이율’을 연단위 복리로 계산한 금액을 더하여 돌려 드립니다.</p>
    </div>

    <div class="termsCon" id="termsPart17">
        <h2 class="termsTit">제17조 (계약내용의 변경 등)</h2>
        <ol class="circleNum">
            <li>① 계약자는 회사의 승낙을 얻어 다음의 사항을 변경할 수 있습니다. 이 경우 승낙을 서면 등으로 알리거나 보험증권의 뒷면에 기재하여 드립니다. 
                <ol class="numList">
                    <li>1. 보험종목</li>
                    <li>2. 보험기간</li>
                    <li>3. 보험료 납입주기, 납입방법 및 납입기간</li>
                    <li>4. 계약자, 피보험자, 보험가입금액 등 기타 계약의 내용</li>
                </ol>
            </li>
            <li>② 회사는 계약자가 제1회 보험료 등을 납입한 때부터 1년 이상 경과된 유효한 계약으로서 그 보험종목의 변경을 요청할 때에는 회사의 사업방법서에서 정하는 방법에 따라 이를 변경하여 드립니다.</li>
            <li>③ 회사는 계약자가 제1항 제4호의 규정에 의하여 보험가입금액을 감액하고자 할 때에는 그 감액된 부분은 계약이 해지된 것으로 보며, 이로 인하여 회사가 환급하여야 할 보험료가 있을 경우에는 제28조(보험료의 환급)에 따라 이를 계약자에게 지급합니다. </li>
            <li>④ 회사는 제1항에 따라 계약자를 변경한 경우, 변경된 계약자에게 보험증권 및 약관을 교부하고 변경된 계약자가 요청하는 경우 약관의 중요한 내용을 설명하여 드립니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart18">
        <h2 class="termsTit">제18조 (조사)</h2>
        <ol class="circleNum">
            <li>① 회사는 보험목적에 대한 위험상태를 조사하기 위하여 보험기간 중 언제든지 피보험자의 시설과 업무내용을 조사할 수 있고 필요한 경우에는 그의 개선을 피보험자에게 요청할 수 있습니다.</li>
            <li>② 회사는 제1항에 따른 개선이 완료될 때까지 계약의 효력을 정지할 수 있습니다.</li>
            <li>③ 회사는 이 계약의 중요사항과 관련된 범위 내에서는 보험기간 중 또는 회사에서 정한 보험금 청구서류를 접수한 날부터 1년 이내에는 언제든지 피보험자의 회계장부를 열람할 수 있습니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart19">
        <h2 class="termsTit">제19조 (타인을 위한 계약)</h2>
        <ol class="circleNum">
            <li>① 계약자는 타인을 위한 계약을 체결하는 경우에 그 타인의 위임이 없는 때에는 반드시 이를 회사에 알려야 하며, 이를 알리지 않았을 때에는 그 타인은 이 계약이 체결된 사실을 알지 못하였다는 사유로 회사에 이의를 제기할 수 없습니다.</li>
            <li>② 타인을 위한 계약에서 보험사고가 발생한 경우에 계약자가 그 타인에게 보험사고의 발생으로 생긴 손해를 배상한 때에는 계약자는 그 타인의 권리를 해하지 않는 범위 내에서 회사에 보험금의 지급을 청구할 수 있습니다.</li>
        </ol>
    </div>


    <h2 class="conTit2 marginTB alignC">제5관 보험료의 납입 </h2>


    <div class="termsCon" id="termsPart20">
        <h2 class="termsTit">제20조 (제1회 보험료 등 및 회사의 보장개시)</h2>
        <ol class="circleNum">
            <li>① 회사는 계약의 청약을 승낙하고 제1회 보험료 등을 받은 때부터 이 약관이 정한 바에 따라 보장을 합니다.</li>
            <li>② 회사가 계약자로부터 계약의 청약과 함께 제1회 보험료 등을 받은 경우에 그 청약을 승낙하기 전에 계약에서 정한 보험사고가 생긴 때에는 회사는 계약상의 보장을 합니다.</li>
            <li>③ 제2항의 규정에도 불구하고 회사는 다음 중 한 가지에 해당되는 경우에는 보장을 하지 않습니다.
                <ol class="numList">
                    <li>1. 제10조(계약 전 알릴 의무)의 규정에 의하여 계약자 또는 피보험자가 회사에 알린 내용이 보험금 지급사유의 발생에 영향을 미쳤음을 회사가 증명하는 경우</li>
                    <li>2. 제3조(보상하지 않는 손해), 제12조(사기에 의한 계약), 제16조(계약의 무효) 또는 제25조(계약의 해지)의 규정을 준용하여 회사가 보장을 하지 않을 수 있는 경우</li>
                </ol>
            </li>
            <li>④ 계약자가 제1회 보험료 등을 자동이체 또는 신용카드로 납입하는 경우에는 자동이체신청 및 신용카드매출 승인에 필요한 정보를 회사에 제공한 때가 제1회 보험료 등을 납입한 때가 되나, 계약자의 책임있는 사유로 자동이체 또는 매출승인이 불가능한 경우에는 제1회 보험료 등이 납입되지 않은 것으로 봅니다.</li>
            <li>⑤ 계약이 갱신되는 경우에는 제1항 내지 제3항에 의한 보장은 기존 계약에 의한 보장이 종료하는 때부터 적용합니다. </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart21">
        <h2 class="termsTit">제21조 (제2회 이후 보험료의 납입)</h2>
        <p>계약자는 제2회 이후의 보험료를 납입기일까지 납입하여야 하며, 회사는 계약자가 보험료를 납입한 경우에는 영수증을 발행하여 드립니다. 다만, 금융회사(우체국을 포함합니다)를 통하여 보험료를 납입한 경우에는 그 금융회사 발행 증빙서류를 영수증으로 대신합니다.</p>
        <div class="boxMade">【납입기일】계약자가 제2회 이후의 보험료를 납입하기로 한 날을 말합니다. </div>
    </div>

    <div class="termsCon" id="termsPart22">
        <h2 class="termsTit">제22조 (보험료의 납입이 연체되는 경우 납입최고(독촉)와 계약의 해지)</h2>
        <ol class="circleNum">
            <li>① 계약자가 제2회 이후의 보험료를 납입기일까지 납입하지 않아 보험료 납입이 연체 중인 경우에 회사는 14일(보험기간이 1년 미만인 경우에는 7일) 이상의 기간을 납입최고(독촉)기간으로 정하여 계약자(타인을 위한 계약의 경우 그 특정된 타인을 포함합니다)에게 다음의 내용을 서면(등기우편 등), 전화(음성녹음) 또는 전자문서 등으로 알려드립니다. 다만, 계약이 해지되기 전에 발생한 보험금 지급사유에 대하여 회사는 계약상의 보장을 합니다.
                <ol class="numList">
                    <li>1. 납입최고(독촉)기간 내에 연체보험료를 납입하여야 한다는 내용</li>
                    <li>2. 납입최고(독촉)기간이 끝나는 날까지 보험료를 납입하지 않을 경우 그 끝나는 날의 다음날에 계약이 해지된다는 내용</li>
                </ol>
            </li>
            <li>② 제1항의 납입최고(독촉)기간은 납입최고(독촉)의 통지가 계약자(타인을 위한 계약의 경우에는 그 특정된 타인을 포함)에게 도달한 날부터 시작되며, 납입최고(독촉)기간의 마지막 날이 영업일이 아닌 때에는 최고(독촉)기간은 그 다음 날까지로 합니다.</li>
            <li>③ 회사가 제1항에 의한 납입최고(독촉) 등을 전자문서로 안내하고자 할 경우에는 계약자의 서면에 의한 동의를 얻어 수신확인을 조건으로 전자문서를 송신하여야 하며, 계약자가 전자문서에 대하여 수신을 확인하기 전까지는 그 전자문서는 송신되지 않은 것으로 봅니다. 회사는 전자문서가 수신되지 않은 것으로 확인되는 경우에는 제1항의 납입최고(독촉)기간을 설정하여 제1항에서 정한 내용을 서면(등기우편 등) 또는 전화(음성녹음)로 다시 알려 드립니다. </li>
            <li>④ 제1항에 따라 계약이 해지된 경우에는 제28조(보험료의 환급)에 따라 보험료를 계약자에게 지급합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart23">
        <h2 class="termsTit">제23조 (보험료의 납입연체로 인한 해지계약의 부활(효력회복))</h2>
        <ol class="circleNum">
            <li>① 제22조(보험료의 납입이 연체되는 경우 납입최고(독촉)와 계약의 해지)에 따라 계약이 해지되었으나 계약자가 제28조(보험료의 환급)에 따라 보험료를 돌려받지 않은 경우 계약자는 해지된 날부터 3년 이내에 회사가 정한 절차에 따라 계약의 부활(효력회복)을 청약할 수 있습니다. 이 경우 회사가 그 청약을 승낙한 때에는 계약자는 부활(효력회복)을 청약한 날까지의 연체된 보험료에 ‘보험개발원이 공시하는 월평균 정기예금이율 +1% 범위내에서 각 상품별로 회사가 정하는 이율로 계산한 금액을 더하여 납입하여야 합니다. </li>
            <li>② 제1항에 따라 해지계약을 부활(효력회복)하는 경우에는 제10조(계약 전 알릴의무), 제12조(사기에 의한 계약), 제13조(보험계약의 성립), 제20조(제1회 보험료 등 및 회사의 보장개시) 및 제25조(계약의 해지)의 규정을 준용합니다. </li>
            <li>③ 제1항에서 정한 계약의 부활이 이루어진 경우라도 계약자 또는 피보험자가 최초계약 청약할 때 제10조(계약 전 알릴 의무)를 위반한 경우에는 제25조(계약의 해지)가 적용됩니다. </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart24">
        <h2 class="termsTit">제24조 (강제집행 등으로 인한 해지계약의 특별부활(효력회복))</h2>
        <ol class="circleNum">
            <li>① 타인을 위한 계약의 경우 제28조(보험료의 환급)에 따른 계약자의 환급금 청구권에 대한 강제집행, 담보권실행, 국세 및 지방세 체납처분절차에 의해 계약이 해지된 경우에는, 회사는 해지 당시의 피보험자가 계약자의 동의를 얻어 계약 해지로 회사가 채권자에게 지급한 금액을 회사에게 지급하고 제17조(계약내용의 변경 등) 제1항의 절차에 따라 계약자 명의를 피보험자로 변경하여 계약의 특별부활(효력회복)을 청약할 수 있음을 피보험자에게 통지하여야 합니다. </li>
            <li>② 회사는 제1항에 의한 계약자 명의변경 신청 및 계약의 특별부활(효력회복) 청약을 승낙하며, 계약은 청약한 때부터 특별부활(효력회복) 됩니다. </li>
            <li>③ 회사는 제1항의 통지를 계약이 해지된 날부터 7일 이내에 하여야 합니다. 다만, 회사의 통지가 7일을 지나서 도달하고 이후 피보험자가 제1항에 의한 계약자 명의변경 신청 및 계약의 특별부활(효력회복)을 청약한 경우에는 계약이 해지된 날부터 7일이 되는 날에 특별부활(효력회복) 됩니다.</li>
            <li>④ 피보험자는 통지를 받은 날부터 15일 이내에 제1항의 절차를 이행할 수 있습니다.</li>
        </ol>
    </div>


    <h2 class="conTit2 marginTB alignC">제6관 계약의 해지 및 보험료의 환급 등</h2>


    <div class="termsCon" id="termsPart25">
        <h2 class="termsTit">제25조 (계약의 해지)</h2>
        <ol class="circleNum">
            <li>① 계약자는 손해가 발생하기 전에는 언제든지 계약을 해지할 수 있습니다. 다만, 타인을 위한 계약의 경우에는 계약자는 그 타인의 동의를 얻거나 보험증권을 소지한 경우에 한하여 계약을 해지할 수 있습니다. </li>
            <li>② 회사는 계약자 또는 피보험자의 고의로 손해가 발생한 경우 이 계약을 해지할 수 있습니다.</li>
            <li>③ 회사는 아래와 같은 사실이 있을 경우에는 손해의 발생여부에 관계없이 그 사실을 안 날부터 1개월 이내에 이 계약을 해지할 수 있습니다. 
                <ol class="numList">
                    <li>1. 계약자, 피보험자 또는 이들의 대리인이 제10조(계약 전 알릴 의무)에도 불구하고 고의 또는 중대한 과실로 중요한 사항에 대하여 사실과 다르게 알린 때</li>
                    <li>2. 뚜렷한 위험의 변경 또는 증가와 관련된 제11조(계약 후 알릴 의무)에서 정한 계약후 알릴 의무를 이행하지 않았을 때</li>
                </ol>
            </li>
            <li>④ 제3항 제1호의 경우에도 불구하고 다음 중 하나에 해당하는 경우에는 회사는 계약을 해지할 수 없습니다.
                <ol class="numList">
                    <li>1. 회사가 계약 할 때에 그 사실을 알았거나 과실로 인하여 알지 못하였을 때</li>
                    <li>2. 회사가 그 사실을 안 날부터 1개월 이상 지났거나 또는 제1회 보험료 등을 받은 때부터 보험금 지급사유가 발생하지 않고 2년이 지났을 때</li>
                    <li>3. 계약을 체결한 날부터 3년이 지났을 때</li>
                    <li>4. 보험을 모집한 자(이하 “보험설계사 등”이라 합니다)가 계약자 또는 피보험자에게 알릴 기회를 주지 않았거나 계약자 또는 피보험자가 사실대로 알리는 것을 방해한 경우, 계약자 또는 피보험자에게 사실대로 알리지 않게 하였거나 부실한 사항을 알릴 것을 권유했을 때. 다만, 보험설계사 등의 행위가 없었다 하더라도 계약자 또는 피보험자가 사실대로 알리지 않거나 부실한 사항을 알렸다고 인정되는 경우에는 계약을 해지할 수 있습니다</li>
                </ol>
            </li>
            <li>⑤ 제3항에 의한 계약의 해지는 손해가 생긴 후에 이루어진 경우에도 회사는 그 손해를 보상하여 드리지 않습니다. 그러나 손해가 제3항 제1호 및 제2호의 사실로 생긴 것이 아님을 계약자 또는 피보험자가 증명한 경우에는 보상하여 드립니다.</li>
            <li>⑥ 회사는 다른 보험가입내역에 대한 계약 전․후 알릴 의무 위반을 이유로 계약을 해지하거나 보험금 지급을 거절하지 않습니다. </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart25">
        <h2 class="termsTit">제25조의2 (위법계약의 해지)</h2>
        <ol class="circleNum">
            <li>① 계약자는 ｢금융소비자 보호에 관한 법률｣ 제47조 및 관련규정이 정하는 바에 따라 계약체결에 대한 회사의 법위반사항이 있는 경우 계약체결일부터 5년 이내의 범위에서 계약자가 위반사항을 안 날부터 1년 이내에 계약해지요구서에 증빙서류를 첨부하여 위법계약의 해지를 요구할 수 있습니다. 다만, 의무보험의 해지를 요구하려는 경우에는 동종의 다른 의무보험에 가입되어 있어야 합니다.</li>
            <li>② 회사는 해지요구를 받은 날부터 10일 이내에 수락여부를 계약자에 통지하여야 하며, 거절할 때에는 거절 사유를 함께 통지하여야 합니다.</li>
            <li>③ 계약자는 회사가 정당한 사유 없이 제1항의 요구를 따르지 않는 경우 해당 계약을 해지할 수 있습니다.</li>
            <li>④ 제1항 및 제3항에 따라 계약이 해지된 경우 회사는 제28조(보험료의 환급) 제1항 제1호에 따른 환급금을 계약자에게 지급합니다. </li>
            <li>⑤ 계약자는 제1항에 따른 제척기간에도 불구하고 민법 등 관계 법령에서 정하는 바에 따라 법률상의 권리를 행사할 수 있습니다. </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart26">
        <h2 class="termsTit">제26조 (중대사유로 인한 해지)</h2>
        <ol class="circleNum">
            <li>① 회사는 아래와 같은 사실이 있을 경우에는 그 사실을 안 날부터 1개월 이내에 계약을 해지할 수 있습니다. 
                <ol class="numList">
                    <li>1. 계약자 또는 피보험자가 보험금을 지급받을 목적으로 고의로 보험금 지급사유를 발생시킨 경우</li>
                    <li>2. 계약자 또는 피보험자가 보험금 청구에 관한 서류에 고의로 사실과 다른 것을 기재하였거나 그 서류 또는 증거를 위조 또는 변조한 경우. 다만, 이미 보험금 지급사유가 발생한 경우에는 보험금 지급에 영향을 미치지 않습니다. </li>
                </ol>
            </li>
            <li>② 회사가 제1항에 따라 계약을 해지한 경우 회사는 그 취지를 계약자에게 통지하고 제28조(보험료의 환급)에 따라 보험료를 계약자에게 지급합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart27">
        <h2 class="termsTit">제27조 (회사의 파산선고와 해지)</h2>
        <ol class="circleNum">
            <li>① 회사가 파산의 선고를 받은 때에는 계약자는 계약을 해지할 수 있습니다.</li>
            <li>② 제1항의 규정에 따라 해지하지 않은 계약은 파산선고 후 3개월이 지난 때에는 그 효력을 잃습니다.</li>
            <li>③ 제1항의 규정에 따라 계약이 해지되거나 제2항의 규정에 의하여 계약이 효력을 잃는 경우에 회사는 제28조(보험료의 환급)에 따라 보험료를 계약자에게 지급합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart28">
        <h2 class="termsTit">제28조 (보험료의 환급)</h2>
        <ol class="circleNum">
            <li>① 이 계약이 무효, 효력상실 또는 해지된 때에는 다음과 같이 보험료를 돌려드립니다. 다만, 보험기간 중 보험사고가 발생하고 보험금이 지급되어 보험가입금액이 감액된 경우에는 감액된 보험가입금액을 기준으로 환급금을 계산하여 돌려드립니다.
                <ol class="numList">
                    <li>1. 계약자 또는 피보험자의 책임 없는 사유에 의하는 경우 : 무효의 경우에는 회사에 납입한 보험료의 전액, 효력상실 또는 해지의 경우에는 경과하지 않은 기간에 대하여 일단위로 계산한 보험료</li>
                    <li>2. 계약자 또는 피보험자의 책임 있는 사유에 의하는 경우 : 이미 경과한 기간에 대하여 단기요율(1년미만의 기간에 적용되는 요율)로 계산한 보험료를 뺀 잔액. 다만 계약자, 피보험자의 고의 또는 중대한 과실로 무효가 된 때에는 보험료를 돌려드리지 않습니다.</li>
                </ol>
            </li>
            <li>② 보험기간이 1년을 초과하는 계약이 무효 또는 효력상실인 경우에는 무효 또는 효력상실의 원인이 생긴날 또는 해지일이 속하는 보험년도의 보험료는 위 제1항의 규정을 적용하고 그 이후의 보험년도에 속하는 보험료는 전액을 돌려드립니다.</li>
            <li>③ 제1항 제2호에서 ‘계약자 또는 피보험자의 책임 있는 사유’라 함은 다음 각 호를 말합니다.
                <ol class="numList">
                    <li>1. 계약자 또는 피보험자가 임의 해지하는 경우</li>
                    <li>2. 회사가 제12조(사기에 의한 계약), 제25조(계약의 해지) 또는 제26조(중대사유로 인한 해지)에 따라 계약을 취소 또는 해지하는 경우</li>
                    <li>3. 보험료 미납으로 인한 계약의 효력 상실</li>
                </ol>
            </li>
            <li>④ 계약의 무효, 효력 상실 또는 해지로 인하여 회사가 돌려드려야 할 보험료가 있을 때에는 계약자는 환급금을 청구하여야 하며, 회사는 청구일의 다음 날부터 지급일까지의 기간에 대하여 ‘보험개발원이 공시하는 보험계약대출이율’을 연단위 복리로 계산한 금액을 더하여 지급합니다.</li>
        </ol>
    </div>

    <h2 class="conTit2 marginTB alignC">제7관 분쟁의 조정 </h2>

    <div class="termsCon" id="termsPart29">
        <h2 class="termsTit">제29조 (분쟁의 조정)</h2>
        <ol class="circleNum">
            <li>① 계약에 관하여 분쟁이 있는 경우에는 분쟁당사자 또는 기타 이해관계인과 회사는 금융감독원장에게 조정을 신청할 수 있으며, 분쟁조정 과정에서 계약자는 관계 법령이 정하는 바에 따라 회사가 기록 및 유지･관리하는 자료의 열람(사본의 제공 또는 청취를 포함한다)을 요구할 수 있습니다. </li>
            <li>② 회사는 일반금융소비자인 계약자가 조정을 통하여 주장하는 권리나 이익의 가액이 ｢금융소비자 보호에 관한 법률｣ 제42조에서 정하는 일정 금액 이내인 분쟁사건에 대하여 조정절차가 개시된 경우에는 관계 법령이 정하는 경우를 제외하고는 소를 제기하지 않습니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart30">
        <h2 class="termsTit">제30조 (관할법원)</h2>
        <p>이 계약에 관한 소송 및 민사조정은 계약자의 주소지를 관할하는 법원으로 합니다. 다만, 회사와 계약자가 합의하여 관할법원을 달리 정할 수 있습니다. </p>
    </div>

    <div class="termsCon" id="termsPart31">
        <h2 class="termsTit">제31조 (소멸시효)</h2>
        <p>보험금청구권, 보험료 또는 환급금 반환청구권은 3년간 행사하지 않으면 시효의 완성으로 소멸합니다.</p>
    </div>

    <div class="termsCon" id="termsPart32">
        <h2 class="termsTit">제32조 (약관의 해석)</h2>
        <ol class="circleNum">
            <li>① 회사는 신의성실의 원칙에 따라 공정하게 약관을 해석하여야 하며 계약자에 따라 다르게 해석하지 않습니다.</li>
            <li>② 회사는 약관의 뜻이 명백하지 않은 경우에는 계약자에게 유리하게 해석합니다.</li>
            <li>③ 회사는 보상하지 않는 손해 등 계약자나 피보험자에게 불리하거나 부담을 주는 내용은 확대하여 해석하지 않습니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart33">
        <h2 class="termsTit">제33조 (설명서 교부 및 보험안내자료 등의 효력))</h2>
        <ol class="circleNum">
            <li>① 회사는 일반금융소비자에게 청약을 권유하거나 일반금융소비자가 설명을 요청하는 경우 보험상품에 관한 중요한 사항을 계약자가 이해할 수 있도록 설명하고 계약자가 이해하였음을 서명(「전자서명법」 제2조 제2호에 따른 전자서명을 포함), 기명날인 또는 녹취 등을 통해 확인받아야 하며, 설명서를 제공하여야 합니다. </li>
            <li>② 설명서, 약관, 계약자 보관용 청약서 및 보험증권의 제공 사실에 관하여 계약자와 회사간에 다툼이 있는 경우에는 회사가 이를 증명하여야 합니다.</li>
            <li>③ 보험설계사 등이 모집과정에서 사용한 회사 제작의 보험안내자료의 내용이 약관의 내용과 다른 경우에는 계약자에게 유리한 내용으로 계약이 성립된 것으로 봅니다.</li>
        </ol>
        <div class="boxMade">【보험안내자료】계약의 청약을 권유하기 위해 만든 서류 등을 말합니다.</div>
    </div>

    <div class="termsCon" id="termsPart34">
        <h2 class="termsTit">제34조 (회사의 손해배상책임)</h2>
        <ol class="circleNum">
            <li>① 회사는 계약과 관련하여 임직원, 보험설계사 및 대리점의 책임있는 사유로 인하여 계약자 및 피보험자에게 발생된 손해에 대하여 관계 법령 등에 따라 손해배상의 책임을 집니다.</li>
            <li>② 회사는 보험금 지급 거절 및 지연지급의 사유가 없음을 알았거나 알 수 있었음에도 불구하고 소를 제기하여 계약자 또는 피보험자에게 손해를 가한 경우에는 그에 따른 손해를 배상할 책임을 집니다.</li>
            <li>③ 회사가 보험금 지급여부 및 지급금액에 관하여 현저하게 공정을 잃은 합의로 계약자 또는 피보험자에게 손해를 가한 경우에도 회사는 제2항에 따라 손해를 배상할 책임을 집니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart35">
        <h2 class="termsTit">제35조 (개인정보보호)</h2>
        <ol class="circleNum">
            <li>① 회사는 이 계약과 관련된 개인정보를 이 계약의 체결, 유지, 보험금 지급 등을 위하여 「개인정보보호법」,「신용정보의 이용 및 보호에 관한 법률」등 관계 법령에 정한 경우를 제외하고 계약자 또는 피보험자의 동의없이 수집, 이용, 조회 또는 제공하지 않습니다. 다만, 회사는 이 계약의 체결, 유지, 보험금 지급 등을 위하여 위 관계 법령에 따라 계약자 및 피보험자의 동의를 받아 다른 회사 및 보험관련단체 등에 개인정보를 제공할 수 있습니다. </li>
            <li>② 회사는 계약과 관련된 개인정보를 안전하게 관리하여야 합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart36">
        <h2 class="termsTit">제36조 (준거법)</h2>
        <p>이 계약은 대한민국 법에 따라 규율되고 해석되며, 약관에서 정하지 않은 사항은 ｢금융소비자 보호에 관한 법률｣, 상법, 민법 등 관계 법령을 따릅니다. </p>
    </div>

    <div class="termsCon" id="termsPart37">
        <h2 class="termsTit">제37조 (예금보험에 의한 지급보장)</h2>
        <p>회사가 파산 등으로 인하여 보험금 등을 지급하지 못할 경우에는 예금자보호법에서 정하는 바에 따라 그 지급을 보장합니다.</p>
    </div>

    <div class="termsCon" id="termsPart37">
        <h2 class="termsTit insuranceTitleB">[부표1] 보험금 지급할 때의 적립이율(보통약관 제6조 제2항 관련)</h2>
        <div class="termsTable">
            <table>
                <caption>서비스 제공에 필요한 최소한의 필수 정보</caption>
                <colgroup>
                    <col style="width:50%">
                    <col style="width:50%">
                </colgroup>
                <thead>
                    <tr>
                    <th scope="col">기 간</th>
                    <th scope="col">지 급 이 자</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td>지급기일의 다음 날부터 30일 이내 기간</td>
                    <td>보험계약대출이율</td>
                    </tr>
                    <tr>
                    <td>지급기일의 31일이후부터 60일이내 기간</td>
                    <td>보험계약대출이율 + 가산이율(4.0%)</td>
                    </tr>
                    <tr>
                    <td>지급기일의 61일이후부터 90일이내 기간</td>
                    <td>보험계약대출이율 + 가산이율(6.0%)</td>
                    </tr>
                    <tr>
                    <td>지급기일의 91일이후 기간</td>
                    <td>보험계약대출이율 + 가산이율(8.0%)</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p>주) 보험계약대출이율은 보험개발원이 공시하는 보험계약대출이율을 적용합니다.</p>
    </div>

    <h2 class="conTit1 insuranceTitleA" style="margin-top:60px;">기업비용보상보험 특별약관</h2>

    <h2 class="conTit2 insuranceTitleB">차량부품수리비용보장 특별약관</h2>

    <div class="termsCon" id="terms2Part1">
        <h2 class="termsTit">제1조 (보상하는 손해)</h2>
        <p>회사는 피보험자가 행사기간 중 판매한 차량의 구입고객에게 ‘차량부품 수리지원 서비스’를 제공함으로 인해 보험기간 중 발생하는 아래 제2조(차량부품 수리지원 서비스)의 서비스 내용에 해당되는 비용을 증권상의 보상한도액 및 자기부담금에 따라 보상하여 드립니다.</p>
    </div>

    <div class="termsCon" id="terms2Part2">
        <h2 class="termsTit">제2조 (차량부품 수리지원 서비스)</h2>
        <ol class="circleNum">
            <li>① 제1조(보상하는 손해)의 ‘차량부품 수리지원 서비스(이하 ‘서비스’)는 아래의 서비스를 말합니다.
                <ol class="numList">
                    <li>1.  서비스 내용 : 서비스에 가입된 차량의 구입고객(이하 ‘서비스 대상고객’)이 아래의 조건에 모두 해당될 경우, 해당 부품을 수리하여 주는 서비스를 말하며 수리가 불가능할 때에는 동등한 성능으로 교체하는 것을 포함합니다. 단, 교체 및 수리 작업은 반드시 피보험자와 보험자가 협의한 전국 지정 정비공장 및 정비센터에 의해 이루어져야 합니다. 
                        <ol class="numList">
                            <li>가. 서비스 대상부품이 해당 부품별 보장기간 중 차대차 사고를 제외한 단독사고로 부품별로 [별첨2]보장부품별 보상조건에 기재된 파손 또는 고장이 발생한 경우</li>
                            <li>나. 피보험차량이 보험증권에 기재된 주행거리를 도달하기 전에 파손 또는 고장이 발생한 경우</li>
                        </ol>
                    </li>
                    <li>2. 서비스 대상차량 : 피보험자가 서비스 대상고객에게 판매한 차량 중 서비스에 가입된 차량으로, 보험증권상 기재된 차량을 말합니다.</li>
                    <li>3. 서비스 대상부품 : [별첨1]보장 대상 부품(이하 ‘보장부품’)을 말합니다.</li>
                </ol>
            </li>
            <li>② 제1항에 의한 수리비용은 피보험자동차를 수리하여 사고 직전의 상태로 원상회복하는데 소요되는 비용으로, 자동차 부품가격 및 수리 인건비 등을 포함한 직접비용(부가세를 포함합니다)을 말합니다. 단, 보험증권에 보상 기준을 별도로 약정한 경우에는 이를 따릅니다. </li>
        </ol>
    </div>

    <div class="termsCon" id="terms2Part3">
        <h2 class="termsTit">제3조 (보상하지 않는 손해)</h2>
        <ol class="circleNum">
            <li>회사는 보통약관 제3조(보상하지 않는 손해)에 추가하여 아래의 사유로 생긴 손해도 보상하여 드리지 않습니다.</li>
            <li>1. 계약자, 피보험자 또는 서비스 대상차량의 소유, 사용 또는 관리자(이하 ‘대상차량관리자’라 합니다) 단독으로 행해졌거나 계약자, 피보험자 또는 서비스 대상차량 관리자의 종업원, 임원, 협력자, 수탁자 또는 승인된 대표자에 의해 다른 사람과 공모하여 행한 사기행위, 고의 또는 기망으로 인한 행위</li>
            <li>2. 차량 제작사 또는 다른 보증프로그램에서 보상되는 손해</li>
            <li>3. 차량의 변형 및 개조에 의한 고장</li>
            <li>4. 도난으로 인한 수리사항이 발생한 경우</li>
            <li>5. 제작증명서나 통관서류가 허위로 작성된 경우</li>
            <li>6. 법령위반(고의 또는 중과실로 법령을 위반하고 법령위반사실과 보험사고간 인과관계가 있는 경우에 한합니다.)</li>
            <li>7. 차량제작자가 권고한 기본 유지관리 방안을 위배하여 발생한 사고</li>
            <li>8. 차량 제작사의 운행능력한계를 초과한 무리한 운행, 적재량 초과, 수리지연에 의한 고장</li>
            <li>9. 회사가 지정하지 않은 수리정비업체에 의한 수리비용</li>
            <li>10. 주행거리계의 고장, 임의변조 또는 교체로 정확한 주행거리를 확인할 수 없는 경우</li>
            <li>11. 경주, 등판능력, 속도 및 내구시험동안 발생한 손해</li>
            <li>12. 피보험자동차가 차량 본래의 용도 이외로 사용되거나 렌터카 및 데모카, 택시, 경찰차 및 군용차 등 긴급목적차량, 경주용차, 공기관등 정부조달차량 등으로 사용되는 차량</li>
            <li>13. 픽업 및 배송, 유상운송, 적재물 운반이나 승객수송, 견인, 도로보수, 건축, 제설 또는 기타 영업목적으로 사용되는 차량</li>
            <li>14. 화재, 폭발에 의한 비용손해</li>
            <li>15. 보장부품의 고장으로 인한 견인비용, 휴업손해 등 간접비용</li>
            <li>16. 타차와의 충돌, 접촉으로 인한 사고 및 자동차보험(공제계약 포함)에서 보상을 받은 경우</li>
            <li>17. 차량 제작사가 공고 또는 리콜을 통해 제조 결함에 대한 교환의 책임을 알린 경우</li>
            <li>18. 국가나 공공단체의 공권력 행사에 의한 압류, 징발, 몰수, 파괴 등으로 인한 손해 그러나 소방이나 피난에 필요한 조치로 손해가 발생한 경우에는 그 손해를 보상합니다.</li>
            <li>19. 일반적 자연 마모로 인한 정상적 교체 주기에 따른 교체</li>
            <li>20. 서비스약관에 기재된 서비스 면책사항</li>
        </ol>
    </div>

    <div class="termsCon" id="terms2Part4">
        <h2 class="termsTit">제4조 (총 보상한도액의 설정)</h2>
        <p>보통약관 제 7 조(보험금 등의 지급한도) 제 2 항에 따라 이 계약에 대하여 회사가 지급하는 총 보상한도액은 보험증권에 기재된 Loss Cap 손해율 ( )%로 합니다.</p>
        <div class="boxMade">【용어의 정의】
            <br>1. Loss Cap 손해율 : 이미 납입한 보험료 합계액(정산보험료 포함) 대비 이미 지급한 보험금 합계액(지급준비금 포함)의 비율로 회사와 계약자가 협의하여 정한 비율(손해율)까지만 보험금을 지급하는 것을 말하며,아래와 같이 계산합니다.
            <br>* LossCap 손해율 = [이미 지급한 보험금 합계액(지급준비금 포함) / 이미 납입한 보험료 합계액(정산보험료포함)] x 100
        </div>
    </div>

    <div class="termsCon" id="terms2Part5">
        <h2 class="termsTit">제5조 (보험가입 대상범위)</h2>
        <p>계약자(피보험자)는 보험가입 당시 회사와 협의하여 정한 보험가입대상 범주에 해당하는 ‘보장대상 서비스 유효계약’ 전부에 대해 이 보험에 가입해야 하며 일부만을 선별하여 가입할 수 없습니다.</p>
    </div>

    <div class="termsCon" id="terms2Part6">
        <h2 class="termsTit">제6조 (보장대상 계약 명세의 통지)</h2>
        <ol class="circleNum">
            <li>① 계약자(피보험자)는 가입된 보장대상 서비스에 대한 서비스 대상고객 성명, 차대번호, 차종, 서비스가입일자, 출고일 등을 회사에 통지해야 합니다. </li>
            <li>② 제 1 항의 통지는 회사와 협의한 일자, 항목 및 양식에 따라 전산 data 로 통지해야 합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="terms2Part7">
        <h2 class="termsTit">제7조 (서비스계약의 해지)</h2>
        <ol class="circleNum">
            <li>① 계약자(피보험자)와 서비스 대상고객간 서비스계약이 해지되는 경우 해지일로부터 해당 개별서비스에 대한 보험보장은 자동 해지됩니다. 이 경우, 해당 개별서비스를 위해 계약자가 기납입한 보험료는 해지시점의 잔여기간에 따른 일할계산을 통해 환급됩니다.</li>
            <li>② 위 제 1 항에 따라 계산된 환급보험료는 매 정산시점 정산보험료에 반영하여 받거나 돌려드립니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="terms2Part8">
        <h2 class="termsTit">제8조 (보험금의 청구)</h2>
        <p>피보험자가 보험금을 청구할 때에는 보통약관 제 5 조(보험금의 청구)의 구비서류 및 다음의 서류를 회사에 제출하여야 합니다.</p>
        <ol class="circleNum">
            <li>1. 서비스 대상고객의 자동차보험가입증명서, 자동차보험 보상 처리 포기 동의서</li>
            <li>2. 서비스 대상차량의 자동차등록증, 수리 전·후 사진</li>
            <li>3. 전국 지정 정비공장 및 정비센터의 수리완료 영수증</li>
            <li>4. 회사가 요구하는 그 밖의 서류</li>
        </ol>
    </div>

    <div class="termsCon" id="terms2Part9">
        <h2 class="termsTit">제9조 (계약자 및 피보험자 준수사항)</h2>
        <ol class="circleNum">
            <li>① 계약자(피보험자)는 이 계약의 체결시점에 약관에 따라 회사와 협의하여 정한 서비스계약서를 발행하여야 하며, 보험기간 중에 이를 변경하고자 하는 경우에는 회사의 사전 서면동의를 받아야 합니다. 회사의 사전동의 없이 변경된 서비스계약서 등에 따른 손해는 보상하지 않습니다.</li>
            <li>② 계약자(피보험자)는 손해액 산정 및 처분절차 수행 등 보험사고 처리와 관련하여 회사가 이의 검증, 참관 및 문서열람, 제출 등을 요구하는 경우, 이에 성실히 협조하여야 합니다.</li>
        </ol>
    </div>
    
    <div class="termsCon" id="terms2Part10">
        <h2 class="termsTit">제10조 (계약의 소멸)</h2>
        <ol class="circleNum">
            <li>① 보험기간 종료일 이전에 서비스 대상차량이 보험증권에 기재된 주행거리에 도달하거나 제 1 조(보상하는 손해) 및 제 4 조(총 보상한도액의 설정)로 인하여 이 약관에서 규정하는 보험금 지급사유가 더 이상 발생 할 수 없는 경우에는 이 계약은 그 때부터 효력이 없습니다.</li>
            <li>② 제 1 항의 주행거리라 함은 계약 개시 이후 주행한 거리로서 보장차량의 odometer(자동차의 주행 거리를 적산(積算)하는 거리계)의 조작, 변경, 초기화 등이 없는 상태에서 표시되는 거리에서 계약 개시 전 거리를 제외한 거리를 말합니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="terms2Part11">
        <h2 class="termsTit">제11조 (양도) </h2>
        <p>보험의 목적의 양도는 회사의 서면동의 없이는 회사에 대하여 효력이 없으며, 회사가 서면 동의한 경우 계약으로 인하여 생긴 권리와 의무를 함께 양도한 것으로 합니다.</p>
    </div>

    <div class="termsCon" id="terms2Part12">
        <h2 class="termsTit">제12조 (준용규정)</h2>
        <p>이 특별약관에 정하지 않은 사항은 보통약관을 따릅니다.</p>
    </div>

    <div class="termsCon">
        <h2 class="termsTit">[별첨1] 보장대상 부품</h2>
        <div class="termsTable">
            <table>
                <colgroup>
                    <col style="width:30%">
                    <col style="width:70%">
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">차량 부품명</th>
                        <th scope="col">부품 설명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p>※ 상기 차량 부품명은 차량 및 제조사에 따라 다른 이름으로 불릴 수 있으며 외관상 차량 부위가 동일하다면 동일한 것으로 합니다.</p>
    </div>

    <div class="termsCon">
        <h2 class="termsTit">[별첨2] 보장부품별 보상 조건</h2>
        <div class="termsTable">
            <table>
                <colgroup>
                    <col style="width:30%">
                    <col style="width:70%">
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">차량 부품명</th>
                        <th scope="col">부품 설명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <h2 class="conTit2 insuranceTitleB">보험료정산 특별약관 Ⅱ</h2>

    <div class="termsCon" id="terms3Part1">
        <h2 class="termsTit">제1조 (보험료의 정산)</h2>
        <ol class="circleNum">
            <li>① 회사는 보통약관 제20조(제1회 보험료 등 및 회사의 보장개시)의 규정에도 불구하고 이 특별약관에 따라 보험료를 정산합니다.</li>
            <li>② 회사는 보통약관 제20조(제1회 보험료 등 및 회사의 보장개시)의 규정에도 불구하고 보험료가 정산되기 이전에 새로이 증가 또는 교체된 피보험자(또는 서비스가입고객)에 대해 생긴 손해를 보상하여 드립니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="terms3Part2">
        <h2 class="termsTit">제2조 (예치보험료)</h2>
        <ol class="circleNum">
            <li>① 회사는 보통약관 제20조(제1회 보험료 등 및 회사의 보장개시)의 규정에도 불구하고 이 특별약관에 따라 보험료를 정산합니다.</li>
            <li>② 회사는 보통약관 제20조(제1회 보험료 등 및 회사의 보장개시)의 규정에도 불구하고 보험료가 정산되기 이전에 새로이 증가 또는 교체된 피보험자(또는 서비스가입고객)에 대해 생긴 손해를 보상하여 드립니다.</li>
        </ol>
    </div>

    <div class="termsCon" id="terms3Part3">
        <h2 class="termsTit">제3조 (보험료 정산기간)</h2>
        <p>계약자는 다음 중 어느 하나의 것으로 보험료를 정산하기로 약정하고, 이 기간을 보험료정산기간 (이하「정산기간」이라 합니다)이라 합니다. </p>
        <ol class="circleNum">
            <li>1. 계약 기간 중
                <ol class="numList">
                    <li>- 매월 □, - 매6개월 □, - 기타 □ ( )</li>
                </ol>
            </li>
            <li>2. 보험기간 종료후 □</li>
        </ol>
    </div>

    <div class="termsCon" id="terms3Part4">
        <h2 class="termsTit">제4조 (보험료의 정산방법)</h2>
        <ol class="circleNum">
            <li>① 계약자는 계약이 효력 상실 또는 해지된 경우에는 효력 상실 또는 해지 일까지의 보험료를 확정하기 위하여 필요한 서류를 효력 상실 또는 해지 즉시 회사에 제출해야 합니다.</li>
            <li>② 회사는 보험기간중이나 보험기간 만료 후 보험료를 산출하기 위하여 필요하다고 인정될 경우에는 계약자의 서류를 열람할 수 있습니다.</li>
            <li>③ 회사는 계약자로부터 정산기간 동안의 피보험자 수 혹은 피보험자(또는 서비스가입고객) 및 보험가입정보를 통지 받아 매 정산기간 종료 후 ( )일 이내에 실제보험료를 산출한 후 제2조(예치보험료)의 예치보험료와의 차액을 받거나 돌려 드립니다.</li>
            <li>④ 보험증권에 최소보험료가 명기되어 있는 경우, 보험기간 동안 산출한 최종 총 보험료가</li>
        </ol>
    </div>

    <div class="termsCon" id="terms3Part5">
        <h2 class="termsTit">제5조 (준용규정)</h2>
        <p>이 특별약관에 정하지 않은 사항은 보통약관을 따릅니다.</p>
    </div>


    <h2 class="conTit2 insuranceTitleB">공동인수 특별약관</h2>


    <div class="termsCon" id="terms4Part1">
        <h2 class="termsTit">제1조(책임의 분담)</h2>
        <p>이 보험증권은 아래의 회사들을 대리하여 ( )가 발행하며 각 회사는 아래 에 명기된 인수비율에 따라 그 책임을 부담합니다.</p>
    </div>

    <div class="termsCon" id="terms4Part2">
        <h2 class="termsTit">제2조 (준용규정)</h2>
        <p>이 특별약관에서 정하지 않은 사항은 보통약관에 따릅니다</p>
    </div>


    <h2 class="conTit2 insuranceTitleB">제재위반 부보장 특별약관</h2>


    <div class="termsCon" id="terms5Part1">
        <h2 class="termsTit">제1조 (보상하지 않는 손해)</h2>
        <p>회사는 아래의 제재에 반하는 위험의 보장, 보험금의 지급 또는 이익의 제공을 하지 않습니다.</p>
        <ol class="circleNum">
            <li>① UN 결의에 의한 제재, 금지, 제한사항</li>
            <li>② EU, 영국 또는 미국의 무역·경제적 제재조치 또는 법률규정</li>
        </ol>
    </div>

    <div class="termsCon" id="terms5Part2">
        <h2 class="termsTit">제2조 (준용규정)</h2>
        <p>이 특별약관에서 정하지 않은 사항은 보통약관을 따릅니다.</p>
    </div>


    <h2 class="conTit2 insuranceTitleB">날짜인식오류 부담보 특별약관</h2>


    <div class="termsCon" id="terms6Part1">
        <h2 class="termsTit">제1조</h2>
        <p>회회사는 보통약관 및 특별약관의 제조건·제규정에 불구하고, 피보험자의 소유여부에 관계없이 컴퓨터, 자료처리기기, 마이크로칩, 운영체제, 마이크로프로세서, 집적회로 및 이와 유사한 장치, 컴퓨터 소프트웨어 또는 이들을 사용하거나 이들과 관련된 생산물, 서비스, 자료, 기능에 있어 어떤 날짜를 정확한 달력날짜로 인식, 처리, 구별, 해석 혹은 받아들일 수 없음으로 인해 발생되는 모든 형태의 직접 또는 간접손해를 보상하지 않습니다. </p>
    </div>

    <div class="termsCon" id="terms6Part2">
        <h2 class="termsTit">제2조</h2>
        <p>회사는 위와 관련한 결함, 논리체계 등을 교정하기 위한 정보처리시스템(EDPS) 또는 그 관련기기 일부분을 수리하거나 수정하는 비용은 보상하지 않습니다.</p>
    </div>

    <div class="termsCon" id="terms6Part3">
        <h2 class="termsTit">제3조</h2>
        <p>회사는 상기 제1조에 기술한 것과 같은 날짜와 관련된 잠재적인 또는 실제적인 고장, 오작동, 부적합 등을 확인, 수정, 시험하기 위하여 피보험자가 자신이나 타인에게 행하였거나 타인으로부터 받은 어떠한 조언, 지도, 설계의 평가, 설치의 검사, 유지관리, 수리 또는 감독상의 오류, 부적절, 오작동으로 인하여 발생되는 손해와 결과적 손실을 보상하지 않습니다.</p>
    </div>

    <div class="termsCon" id="terms6Part4">
        <h2 class="termsTit">제4조</h2>
        <p>상기 제1조, 제2조, 제3조에 기술한 손해 또는 결과적 손실은 다른 사고원인과 병합 또는 관련된 경우에도 보상하지 않습니다.</p>
    </div>

    <h2 class="conTit2 insuranceTitleB">COMMUNICABLE DISEASE EXCLUSION [LMA5399]</h2>

    <div class="termsCon" id="terms6Part4">
        <ol class="circleNum">
            <li>1. Notwithstanding any provision to the contrary within this (re)insurance agreement, this (re)insurance agreement excludes all actual or alleged loss, liability, damage, compensation, injury, sickness, disease, death, medical payment, defense cost, cost, expense or any other amount incurred by or accruing to the (re)insured, directly or indirectly and regardless of any other cause contributing concurrently or in any sequence, originating from, caused by, arising out of, contributed to by, resulting from, or otherwise in connection with a Communicable Disease or the fear or threat (whether actual or perceived) of a Communicable Disease.</li>
            <li>2. As used herein, a Communicable Disease means any disease which can be transmitted by means of any substance or agent from any organism to another organism where:
                <ol class="numList">
                    <li>2.1. the substance or agent includes, but is not limited to, a virus, bacterium, parasite or other organism or any variation thereof, whether deemed living or not, and</li>
                    <li>2.2. the method of transmission, whether direct or indirect, includes but is not limited to, airborne transmission, bodily fluid transmission, transmission from or to any surface or object, solid, liquid or gas or between organisms, and</li>
                    <li>2.3. the disease, substance or agent can cause or threaten bodily injury, illness, emotional distress or damage to human health, human welfare or property damage.</li>
                </ol>
            </li>
        </ol>
    </div>

    <div class="termsCon">
        <p>The below version in Korean language is for translation purpose only. In case of any discrepancy between the English version (which is original) and the Korean version (which is for translation purpose only), the English version always prevails and shall be the only original contractual wording binding on the parties in case of any dispute.</p>
    </div>

    <h2 class="conTit2 marginTB alignC">[LMA5399] 감염병 면책 조항</h2>

    <div class="termsCon" id="terms6Part4">
        <ol class="circleNum">
            <li>1. 본 (재)보험 계약상 반대되는 조항이 있다고 하더라도 감염병 또는 감염병에 대한 (실제 또는 인식된) 공포 및 위협으로 인해 (출재)보험사에 직간접적으로 야기, 기여, 기인되거나 원인 또는 연관이 되어 발생하는 모든 실제 또는 추정 손실, 배상책임, 피해보상, 상해, 병, 질병, 사망, 의료 비용, 방어 비용, 일반 비용, 경비 또는 기타 비용은 본 (재)보험의 보상 범위에서 제외되며, 그러한 손실 등의 발생에 기여하는 다른 원인이 동시에 혹은 어떠한 순서 에 따라 발생했는지 여부와 관계없이 제외됩니다.</li>
            <li>2. 본 계약서상에서 사용되는 감염병이라는 용어는 어느 한 유기체에서 다른 유기체로 어떠한 물질 또는 매개체를 통해 전파되는 모든 질병을 의미하며 아래의 경우가 해당됩니다. 
                <ol class="numList">
                    <li>2.1 해당 물질 또는 매개체에는 바이러스, 박테리아, 기생충 또는 기타 유기체나 그 변종 등을 포함하되 이에 한정되지 않으며, 살아있다고 인식되는지 여부는 불문</li>
                    <li>2.2 직간접적으로 전파되는 형태에는 공기 중 전염, 체액을 통한 전염, 물체의 표면 또는 고체, 액체, 기체 등의 20 기업비용보상보험 물체를 통한 전염, 또는 유기체 간의 전염 등이 포함되며 이에 한정되지 아니함</li>
                    <li>2.3 해당 질병, 전염 물질 또는 매개체가 신체 상해, 질환 및 정신적 피해 또는 인간의 건강과 안위에 대한 피해를 야기하거나 그러한 피해가 발생할 수 있는 위협이 되는 경우 또는 재물의 피해를 야기하거나 피해가 발생할 수 있는 위협이 되는 경우</li>
                </ol>
            </li>
        </ol>
    </div>

    <div class="termsCon">
        <p>이하의 국문은 위 영문 원본을 이해를 돕기 위한 번역본입니다. 영문본(원본)과 국문본(번역본) 사이에 여하한 상이점이 있을 경우, 언제나 영문본이 우선하며, 오로지 영문본만이 분쟁 발생시 당사자 사이의 유일한 구속력 있는 합의가 됩니다.</p>
    </div>


</section>
</template>

<script>
export default {
    name: 'TermInsurance'
}
</script>

<style lang="scss" scoped>
</style>